import React, { useState } from 'react';
import { Table, Button, Card, Form, Row, Col } from 'react-bootstrap';
import { FaSync, FaFileExcel, FaTimes } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const GridComFixa = ({ codigoFamilia, comFixa, onRecarregar }) => {
  const [imoveis, setImoveis] = useState(null);
  const [editando, setEditando] = useState({});
  const [gerando, setGerando] = useState(false);
  const [filtroQuadra, setFiltroQuadra] = useState('');
  const [filtroLoteIni, setFiltroLoteIni] = useState('');
  const [filtroLoteFim, setFiltroLoteFim] = useState('');

  const listaImoveis = imoveis != null ? imoveis : (comFixa != null ? comFixa.imoveis : null);
  const tipos = comFixa != null && comFixa.tipos_comissao != null ? comFixa.tipos_comissao : [];

  const temFiltro = filtroQuadra !== '' || filtroLoteIni !== '' || filtroLoteFim !== '';

  const imoveisFiltrados = (listaImoveis != null ? listaImoveis : []).filter((item) => {
    if (filtroQuadra !== '') {
      const qd = item.quadra != null ? item.quadra.toUpperCase() : '';
      if (qd.indexOf(filtroQuadra.toUpperCase()) === -1) return false;
    }
    if (filtroLoteIni !== '') {
      const loteNum = item.lote != null ? parseInt(item.lote, 10) : NaN;
      if (!isNaN(loteNum) && loteNum < parseInt(filtroLoteIni, 10)) return false;
    }
    if (filtroLoteFim !== '') {
      const loteNum = item.lote != null ? parseInt(item.lote, 10) : NaN;
      if (!isNaN(loteNum) && loteNum > parseInt(filtroLoteFim, 10)) return false;
    }
    return true;
  });

  const handleLimparFiltros = () => {
    setFiltroQuadra('');
    setFiltroLoteIni('');
    setFiltroLoteFim('');
  };

  const handleCelulaClick = (codigoAtivo, codigoTipo, valorAtual) => {
    const chave = codigoAtivo + '-' + codigoTipo;
    setEditando((prev) => ({
      ...prev,
      [chave]: valorAtual != null ? String(valorAtual) : '',
    }));
  };

  const handleCelulaBlur = async (item, codigoTipo, chave) => {
    const novoValorStr = editando[chave];
    const novoValor = novoValorStr !== '' ? Number(novoValorStr) : null;
    const valorAtual =
      item.comissoes != null && item.comissoes[codigoTipo] != null
        ? item.comissoes[codigoTipo]
        : null;

    if (String(novoValor) === String(valorAtual)) {
      setEditando((prev) => {
        const copia = Object.assign({}, prev);
        delete copia[chave];
        return copia;
      });
      return;
    }

    try {
      await api.salvarComFixaValor({
        imovel: item.codigo_ativo,
        codigo_tipo: codigoTipo,
        valor: novoValor,
      });
      toast.success('Valor salvo!');
      setImoveis((prev) => {
        const lista = prev != null ? prev : (comFixa != null ? comFixa.imoveis : []);
        return lista.map((im) => {
          if (im.codigo_ativo !== item.codigo_ativo) return im;
          const novasComissoes = Object.assign({}, im.comissoes, { [codigoTipo]: novoValor });
          return Object.assign({}, im, { comissoes: novasComissoes });
        });
      });
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao salvar valor';
      toast.error(msg);
    } finally {
      setEditando((prev) => {
        const copia = Object.assign({}, prev);
        delete copia[chave];
        return copia;
      });
    }
  };

  const handleGerar = async () => {
    if (!window.confirm('Gerar substituirá TODA a grade de comissão fixa. Confirma?')) return;
    setGerando(true);
    try {
      await api.gerarComFixa({ codigo_familia: codigoFamilia });
      toast.success('Grade gerada com sucesso!');
      setImoveis(null);
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao gerar grade';
      toast.error(msg);
    } finally {
      setGerando(false);
    }
  };

  const handleExportar = () => {
    if (imoveisFiltrados.length === 0) {
      toast.error('Nenhum registro para exportar.');
      return;
    }
    let csv = 'Quadra;Lote;M2;Qualidade';
    tipos.forEach((t) => { csv += ';' + (t.sigla || t.descricao); });
    csv += '\n';
    imoveisFiltrados.forEach((item) => {
      csv += (item.quadra || '') + ';' + (item.lote || '') + ';' + (item.m2 != null ? item.m2 : '') + ';' + (item.qualidade || '');
      tipos.forEach((t) => {
        const val = item.comissoes != null && item.comissoes[t.codigo_tipo] != null ? item.comissoes[t.codigo_tipo] : '';
        csv += ';' + val;
      });
      csv += '\n';
    });
    const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'comissao_por_imovel.csv';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Comissão Fixa por Imóvel</strong>
        <div>
          <Button size="sm" variant="outline-success" className="mr-2" onClick={handleExportar}>
            <FaFileExcel className="mr-1" /> Exportar CSV
          </Button>
          <Button size="sm" variant="warning" onClick={handleGerar} disabled={gerando}>
            <FaSync className="mr-1" /> Gerar Grade
          </Button>
        </div>
      </Card.Header>
      <Card.Body className="p-0">
        {comFixa == null && (
          <p className="text-muted p-3 mb-0">Clique em Gerar para criar a grade.</p>
        )}
        {comFixa != null && (
          <>
            <div className="p-2 border-bottom bg-light">
              <Row className="align-items-end">
                <Col md={2}>
                  <Form.Group className="mb-0">
                    <Form.Label className="small mb-0">Quadra</Form.Label>
                    <Form.Control
                      size="sm"
                      value={filtroQuadra}
                      onChange={(e) => setFiltroQuadra(e.target.value)}
                      placeholder="Filtrar quadra"
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group className="mb-0">
                    <Form.Label className="small mb-0">Lote Inicial</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      value={filtroLoteIni}
                      onChange={(e) => setFiltroLoteIni(e.target.value)}
                      placeholder="De"
                    />
                  </Form.Group>
                </Col>
                <Col md={2}>
                  <Form.Group className="mb-0">
                    <Form.Label className="small mb-0">Lote Final</Form.Label>
                    <Form.Control
                      size="sm"
                      type="number"
                      value={filtroLoteFim}
                      onChange={(e) => setFiltroLoteFim(e.target.value)}
                      placeholder="Até"
                    />
                  </Form.Group>
                </Col>
                <Col md={3} className="d-flex align-items-end">
                  {temFiltro && (
                    <Button size="sm" variant="outline-secondary" onClick={handleLimparFiltros}>
                      <FaTimes className="mr-1" /> Limpar
                    </Button>
                  )}
                  <span className="ml-2 small text-muted">
                    {imoveisFiltrados.length} imóvel(is)
                  </span>
                </Col>
              </Row>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <div style={{ maxHeight: 300, overflowY: 'auto' }}>
              <Table striped bordered hover size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th>Quadra</th>
                    <th>Lote</th>
                    <th>M²</th>
                    <th>Qualidade</th>
                    {tipos.map((t) => (
                      <th
                        key={'th-tipo-' + t.codigo_tipo}
                        style={{
                          backgroundColor: t.cor != null ? t.cor : undefined,
                          color: t.cor != null ? '#fff' : undefined,
                        }}
                      >
                        {t.sigla}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {imoveisFiltrados.length === 0 && (
                    <tr>
                      <td colSpan={4 + tipos.length} className="text-center text-muted">
                        Nenhum imóvel na grade
                      </td>
                    </tr>
                  )}
                  {imoveisFiltrados.map((item) => (
                    <tr key={'comfixa-' + item.codigo_ativo}>
                      <td>{item.quadra}</td>
                      <td>{item.lote}</td>
                      <td>{item.m2}</td>
                      <td>{item.qualidade}</td>
                      {tipos.map((t) => {
                        const chave = item.codigo_ativo + '-' + t.codigo_tipo;
                        const emEdicao = Object.prototype.hasOwnProperty.call(editando, chave);
                        const valorAtual =
                          item.comissoes != null && item.comissoes[t.codigo_tipo] != null
                            ? item.comissoes[t.codigo_tipo]
                            : '';
                        return (
                          <td
                            key={'cell-' + item.codigo_ativo + '-' + t.codigo_tipo}
                            style={{ cursor: 'pointer', minWidth: 80 }}
                            onClick={
                              !emEdicao
                                ? () => handleCelulaClick(item.codigo_ativo, t.codigo_tipo, valorAtual)
                                : undefined
                            }
                          >
                            {emEdicao ? (
                              <Form.Control
                                size="sm"
                                type="number"
                                value={editando[chave]}
                                autoFocus
                                onChange={(e) =>
                                  setEditando((prev) =>
                                    Object.assign({}, prev, { [chave]: e.target.value })
                                  )
                                }
                                onBlur={() => handleCelulaBlur(item, t.codigo_tipo, chave)}
                                style={{ minWidth: 70 }}
                              />
                            ) : (
                              valorAtual
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </Table>
              </div>
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default GridComFixa;
